import { Offer, OfferType } from '../types';

function getOfferType(offer: Offer): OfferType | null {
    if (offer.shifts?.length) {
        return 'Shifts';
    }

    if (offer.periods?.length) {
        return 'Weeks';
    }

    return null;
}

export default getOfferType;
